import tabItems from "@/views/boards/tab/tab-items";

export default (availableBoardIds) => {
  return Object.entries(tabItems)
    .filter(([, item]) => item.isApproval === true)
    .filter(([id]) => {
      if (!availableBoardIds || availableBoardIds.length === 0) return true;
      return availableBoardIds.includes(Number(id));
    })
    .map(([id, item]) => ({ text: item.label, value: Number(id) }))
    .sort((a, b) => a.text.localeCompare(b.text, 'ko'));
};
